import { CalendarItemUnion } from '$tablet-app/src/app/calendar/types';
import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import { getStartDate } from '@akin-home/calendar';
import React, { FC, PropsWithChildren, useMemo } from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import BreakDownScheduleItem from './BreakDownScheduleItem';

interface Props {
  items?: CalendarItemUnion[];

  onPressItem?: (item: CalendarItemUnion) => void;
}

const empty_items: CalendarItemUnion[] = [];

const CalendarDayBreakdownSchedule: FC<Props> = (props) => {
  const { items = empty_items, onPressItem } = props;

  /**
   * Items are grouped into the following breakdown
   * 12am
   * 6am
   * 12pm
   * 6pm
   * */
  const items_grouped_by_time_of_day = useMemo(
    () => [
      items.filter((item) => getStartDate(item).getHours() < 6),
      items.filter(
        (item) =>
          6 <= getStartDate(item).getHours() &&
          getStartDate(item).getHours() < 12
      ),
      items.filter(
        (item) =>
          12 <= getStartDate(item).getHours() &&
          getStartDate(item).getHours() < 18
      ),
      items.filter((item) => getStartDate(item).getHours() >= 18),
    ],
    [items]
  );

  return (
    <ScrollView contentContainerStyle={{ paddingBottom: 80 }}>
      <TimeBreak>12 AM</TimeBreak>
      {items_grouped_by_time_of_day[0].map((item) => (
        <CardContainer key={item.id}>
          <BreakDownScheduleItem item={item} onPress={onPressItem} />
        </CardContainer>
      ))}

      <TimeBreak>6 AM</TimeBreak>
      {items_grouped_by_time_of_day[1].map((item) => (
        <CardContainer key={item.id}>
          <BreakDownScheduleItem item={item} onPress={onPressItem} />
        </CardContainer>
      ))}

      <TimeBreak>12 PM</TimeBreak>
      {items_grouped_by_time_of_day[2].map((item) => (
        <CardContainer key={item.id}>
          <BreakDownScheduleItem item={item} onPress={onPressItem} />
        </CardContainer>
      ))}

      <TimeBreak>6 PM</TimeBreak>
      {items_grouped_by_time_of_day[3].map((item) => (
        <CardContainer key={item.id}>
          <BreakDownScheduleItem item={item} onPress={onPressItem} />
        </CardContainer>
      ))}
    </ScrollView>
  );
};

const TimeBreak: FC<PropsWithChildren> = ({ children }) => (
  <TimeBreakRow alignItems="center" justifyContent="center">
    <TimeBreakLine />
    <TimeBreakText variant="caption" weight="semibold">
      {children}
    </TimeBreakText>
    <TimeBreakLine />
  </TimeBreakRow>
);

const TimeBreakRow = styled(Row)`
  margin: 8px 0;
`;

const TimeBreakLine = styled.View`
  height: 1px;
  flex: 1;

  background-color: rgba(221, 221, 221, 1);
`;

const TimeBreakText = styled(Text)`
  color: rgba(5, 22, 51, 0.5);

  margin-left: 8px;
  margin-right: 8px;
`;

const CardContainer = styled.View`
  padding: 8px 16px;
`;

export default CalendarDayBreakdownSchedule;
